import { userConstants } from "../../constant";

export function productsListing(state = {}, action) {
  switch (action.type) {
    case userConstants.PRODUCTS_LISTING:
      return {
        productsList: action.products,
      };
    default:
      return state;
  }
}
